const DEV_HINT =
  "Caso ache que tem algo errado ou tiver uma sugestão, fale com o DEV.";

export const NEMO_ERROR_REPLY =
  "Não consegui falar com a IA agora. Entre em contato com o DEV.";

const EXPLAINABLE_MESSAGE =
  /^(Formato não suportado\b|O arquivo |O tipo do arquivo |O total de anexos excede o limite\b|Não foi possível ler\b|Esse envio passou do que a IA consegue ler\b|Esse PDF tem páginas demais\b)/;

/** Mensagem da bolha de erro. Falha desconhecida continua no texto genérico. */
export function nemoErrorReply(
  serverMessage?: string,
  partialContent = "",
): string {
  const explanation = explainNemoError(serverMessage);
  const partial = partialContent.trim();

  if (!explanation) return partial || NEMO_ERROR_REPLY;
  if (!partial) return explanation;
  return `${partial}\n\n${explanation}`;
}

/** Alerta de anexo e erros já escritos para o usuário. */
export function explainNemoError(serverMessage?: string): string | null {
  const translated = translateProviderError(serverMessage);
  const message = (translated || serverMessage || "").trim();
  if (!message || !EXPLAINABLE_MESSAGE.test(message)) return null;
  if (message.includes("fale com o DEV")) return message;
  return `${message} ${DEV_HINT}`;
}

function translateProviderError(serverMessage?: string): string | null {
  const text = serverMessage || "";

  if (/context window/i.test(text)) {
    return "Esse envio passou do que a IA consegue ler de uma vez. Tente menos texto, menos anexos ou um arquivo menor.";
  }

  const pdfPages = text.match(/maximum of (\d+) PDF pages/i);
  if (pdfPages || /pdf pages may be provided/i.test(text)) {
    const limit = pdfPages?.[1] || "600";
    return `Esse PDF tem páginas demais para a IA ler. O limite é de ${limit} páginas. Envie só a parte que importa, ou divida o arquivo.`;
  }

  return null;
}
